import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/user/LoginPage";
import "./App.scss";
import MainLayout from "./layout/MainLayout";
import UserManagementPage from "./pages/management/UserManagementPage";
import UserManagementDetailPage from "./pages/management/UserManagementDetailPage";
import SystemCodeManagementPage from "./pages/management/SystemCodeManagementPage";
import SystemCodeManagementEditPage from "./pages/management/SystemCodeManagementEditPage";
import UnitCodeManagementPage from "./pages/management/UnitCodeManagementPage";
import UnitCodeManagementEditPage from "./pages/management/UnitCodeManagementEditPage";
import ItemCodeManagementPage from "./pages/management/ItemCodeManagementPage";
import ItemCodeManagementEditPage from "./pages/management/ItemCodeManagementEditPage";
import PdiMenuManagementPage from "./pages/management/PdiMenuManagementPage";
import PdiMenuManagementEditPage from "./pages/management/PdiMenuManagementEditPage";
import UserRequestManagementPage from "./pages/management/UserRequestManagementPage";
import DeviceManagementPage from "./pages/management/DeviceManagementPage";
import AuthorityManagementPage from "./pages/management/AuthorityManagementPage";
import SignUpLayout from "./layout/SignUpLayout";
import RegOrganizationPage from "./pages/user/RegOrganizationPage";
import RegAgreementPage from "./pages/user/RegAgreementPage";
import RegRequiredInfoPage from "./pages/user/RegRequiredInfoPage";
import RegConfirmPage from "./pages/user/RegConfirmPage";
import UnblockIdPage from "./pages/user/UnblockIdPage";
import FindInfoPage from "./pages/user/FindInfoPage";
import ApproveIdPage from "./pages/user/ApproveIdPage";
import ChangePwdPage from "./pages/user/ChangePwdPage";
import MyPage from "./pages/user/MyPage";
import ErrorPage from "./pages/ErrorPage";
import { useSelector } from "react-redux";
import RegWaCheckPage from "./pages/user/RegWaCheckPage";
import RegionalRecordPage from "./pages/pdistatus/RegionalRecordPage";
import VinHistoryPage from "./pages/pdistatus/VinHistoryPage";
import NgCheckListPage from "./pages/pdistatus/NgCheckListPage";
import CheckPwdPage from "./pages/user/CheckPwdPage";
import MainNoticePage from "./pages/notice/MainNoticePage";
import MainNoticeViewPage from "./pages/notice/MainNoticeViewPage";
import InspectionMasterManagementPage from "./pages/management/InspectionMasterManagementPage";
import InspectionMasterAddFilePage from "./pages/management/InspectionMasterAddFilePage";
import ApplicationManagementPage from "./pages/management/ApplicationManagementPage";
import ApplicationAddFilePage from "./pages/management/ApplicationAddFilePage";
import DiageDBManagementPage from "./pages/management/DiagDBManagementPage";
import DiagDBAddFilePage from "./pages/management/DiagDBAddFilePage";
import LutTabManagementPage from "./pages/management/LutTabManagementPage";
import LutTabAddFilePage from "./pages/management/LutTabAddFilePage";
import FirmwareManagementPage from "./pages/management/FirmwareManagementPage";
import FirmwareAddFilePage from "./pages/management/FirmwareAddFilePage";
import CommAppManagementPage from "./pages/management/CommAppManagementPage";
import CommAppAddFilePage from "./pages/management/CommAppAddFilePage";
import Vci2VersionManagementPage from "./pages/management/Vci2VersionManagementPage";
import Vci2VersionAddPage from "./pages/management/Vci2VersionAddPage";
import LogManagementPage from "./pages/management/LogManagementPage";
import ErrorReportingLogManagementPage from "./pages/management/ErrorReportingLogManagementPage";
import UnsupportCarManagementPage from "./pages/management/UnsupportCarManagementPage";
import DealerCodeManagementPage from "./pages/management/DealerCodeManagementPage";
import DefectTrendAnalysisPage from "./pages/qualityanalysis/DefectTrendAnalysisPage";

function App() {
  const AuthRoute = ({ element: Component }) => {
    const location = useLocation();
    const menuAuthInfo = useSelector((state) => state.menuAuth.menuAuthInfo);

    // menuAuthInfo가 로딩되지 않았다면 아무것도 렌더링하지 않음
    if (menuAuthInfo === null || menuAuthInfo === undefined) {
      return null;
    }

    const isAuthorized = menuAuthInfo.some(
      (menuAuth) =>
        menuAuth.url &&
        (location.pathname === menuAuth.url ||
          location.pathname.startsWith(menuAuth.url + "/")) &&
        menuAuth.view === true
    );

    if (!isAuthorized) {
      return <Navigate to="/error" replace={true} />;
    }

    return Component;
  };

  const menuRoutes = [
    { path: "/manage/user", element: <UserManagementPage /> },
    { path: "/manage/user/detail", element: <UserManagementDetailPage /> },
    { path: "/manage/systemcode", element: <SystemCodeManagementPage /> },
    {
      path: "/manage/systemcode/edit",
      element: <SystemCodeManagementEditPage />,
    },
    { path: "/manage/itemcode", element: <ItemCodeManagementPage /> },
    { path: "/manage/itemcode/edit", element: <ItemCodeManagementEditPage /> },
    { path: "/manage/unitcode", element: <UnitCodeManagementPage /> },
    { path: "/manage/unitcode/edit", element: <UnitCodeManagementEditPage /> },
    { path: "/manage/dealercode", element: <DealerCodeManagementPage /> },
    { path: "/manage/pdimenu", element: <PdiMenuManagementPage /> },
    { path: "/manage/pdimenu/edit", element: <PdiMenuManagementEditPage /> },
    { path: "/manage/userrequest", element: <UserRequestManagementPage /> },
    { path: "/manage/device", element: <DeviceManagementPage /> },
    { path: "/manage/authority", element: <AuthorityManagementPage /> },
    { path: "/manage/inspmaster", element: <InspectionMasterManagementPage /> },
    {
      path: "/manage/inspmaster/add",
      element: <InspectionMasterAddFilePage />,
    },
    { path: "/manage/application", element: <ApplicationManagementPage /> },
    { path: "/manage/application/add", element: <ApplicationAddFilePage /> },
    { path: "/manage/diagdb", element: <DiageDBManagementPage /> },
    { path: "/manage/diagdb/add", element: <DiagDBAddFilePage /> },
    { path: "/manage/luttab", element: <LutTabManagementPage /> },
    { path: "/manage/luttab/add", element: <LutTabAddFilePage /> },
    { path: "/manage/firmware", element: <FirmwareManagementPage /> },
    { path: "/manage/firmware/add", element: <FirmwareAddFilePage /> },
    { path: "/manage/commapp", element: <CommAppManagementPage /> },
    { path: "/manage/commapp/add", element: <CommAppAddFilePage /> },
    { path: "/manage/vci2version", element: <Vci2VersionManagementPage /> },
    { path: "/manage/vci2version/add", element: <Vci2VersionAddPage /> },
    { path: "/manage/log-management", element: <LogManagementPage /> },
    {
      path: "/manage/error-log",
      element: <ErrorReportingLogManagementPage />,
    },
    { path: "/manage/unsupportcar", element: <UnsupportCarManagementPage /> },
    {
      path: "/pdi-status/regional-record",
      element: <RegionalRecordPage />,
    },
    {
      path: "/pdi-status/vin-history",
      element: <VinHistoryPage />,
    },
    {
      path: "/pdi-status/ng-check",
      element: <NgCheckListPage />,
    },
    {
      path: "/quality-analysis/defect-trend",
      element: <DefectTrendAnalysisPage />,
    },
    { path: "/notice/main", element: <MainNoticePage /> },
    { path: "/notice/main/view", element: <MainNoticeViewPage /> },
    { path: "/notice/main/view/:id", element: <MainNoticeViewPage /> },
  ];

  const joinRoutes = [
    { path: "/join/reg-wacheck", element: <RegWaCheckPage /> },
    { path: "/join/reg-org", element: <RegOrganizationPage /> },
    { path: "/join/reg-agreement", element: <RegAgreementPage /> },
    { path: "/join/reg-info", element: <RegRequiredInfoPage /> },
    { path: "/join/reg-confirm", element: <RegConfirmPage /> },
    { path: "/join/unblock", element: <UnblockIdPage /> },
    { path: "/join/find-info", element: <FindInfoPage /> },
    { path: "/join/approval", element: <ApproveIdPage /> },
    { path: "/join/changepw", element: <ChangePwdPage /> },
  ];

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            sessionStorage.getItem("userInfo") ? (
              <Navigate to="/pdi-status/regional-record" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route element={<MainLayout />}>
          <Route path="/mypage/checkpw" element={<CheckPwdPage />} />
          <Route path="/mypage/main" element={<MyPage />} />
          {menuRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<AuthRoute element={element} />}
            />
          ))}
        </Route>

        <Route element={<SignUpLayout />}>
          {joinRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/*" element={<ErrorPage errorCode="404" />} />
      </Routes>
    </Router>
  );
}

export default App;
